import type { Identity } from "./api";

export function Brand() {
  return (
    <div className="brand" aria-label="RPControl">
      <span>RPControl</span>
    </div>
  );
}

type NavigationItem = {
  id: string;
  label: string;
};

export function AuthenticatedHeader({
  identity,
  navigation = [],
  activeNavigation,
  onNavigate,
  onSignOut,
}: {
  identity: Identity;
  navigation?: NavigationItem[];
  activeNavigation?: string;
  onNavigate?: (id: string) => void;
  onSignOut: () => void;
}) {
  const sandboxPublisherID = new URLSearchParams(window.location.search).get("sandbox");
  const customerTenantID = new URLSearchParams(window.location.search).get("customer");
  const initials = identity.email
    .split("@", 1)[0]
    .split(/[._-]+/)
    .map((part) => part[0] ?? "")
    .join("")
    .slice(0, 2)
    .toUpperCase();
  const role = sandboxPublisherID ? "Sandbox-Kunden-Admin" : identity.role === "platform_admin" ? "Betreiber-Admin" : identity.role === "admin" ? "Kunden-Admin" : "Auswertung";

  return (
    <header className="topbar">
      <div className="brand-context"><a className="brand-link" href={customerTenantID ? `/?customer=${encodeURIComponent(customerTenantID)}` : sandboxPublisherID ? `/?sandbox=${encodeURIComponent(sandboxPublisherID)}` : "/"} aria-label="RPControl Startseite"><Brand /></a>
      {customerTenantID && <span className="customer-access-badge">Betreiberzugang · {identity.tenant}</span>}</div>
      {navigation.length > 0 && (
        <nav className="main-navigation" aria-label="Hauptnavigation">
          {navigation.map((item) => (
            <button
              key={item.id}
              type="button"
              className={activeNavigation === item.id ? "active" : ""}
              aria-current={activeNavigation === item.id ? "page" : undefined}
              onClick={() => onNavigate?.(item.id)}
            >
              {item.label}
            </button>
          ))}
        </nav>
      )}
      <details className="account-menu">
        <summary aria-label={`Benutzermenü für ${identity.email}`}><span>{initials || "SE"}</span></summary>
        <div className="account-popover">
          <strong>{identity.email}</strong>
          <span>{identity.tenant} · {role}</span>
          <button type="button" onClick={onSignOut}>Abmelden</button>
        </div>
      </details>
    </header>
  );
}
